import { NgModule } from '@angular/core';

import { LottieDirectiveSharedModule } from '@shared/core/directives/lottie/lottie.directive.shared.module';
import { FormForBirthdayRewardsModule } from '@shared/core/modules/forms/formTypes/forBirthdayRewards';

import { AuthComponentsModule } from '../../components';

import { AuthForBirthdayRewardsComponent } from './auth-for-birthday-rewards.shared.component';

@NgModule({
    declarations: [
        AuthForBirthdayRewardsComponent
    ],
    imports: [
        LottieDirectiveSharedModule,
        AuthComponentsModule,
        FormForBirthdayRewardsModule,
    ],
    exports: [
        AuthForBirthdayRewardsComponent
    ],
})
export class AuthForBirthdayRewardsModule { }
